module.exports = __webpack_public_path__ + "img/1536198867.4cd72842.jpg";